<template>
  <div>
    <h2>
      <span class="step-name">
        This season Dry-off
      </span>
      <comments field-name="heading_this_season_dryoff"  :isReadOnly="isReadOnly"></comments>
    </h2>

    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <number-input label="Cows"
                        :field-name="`farm_${farm.id}-cows_at_dryoff`"
                        :disabled="isReadOnly">
          </number-input>

          <number-input label="Heifers"
                        :field-name="`farm_${farm.id}-heifers_at_dryoff`"
                        :disabled="isReadOnly">
          </number-input>

          <date-input label="Earliest dry-off date"
                      :field-name="`farm_${farm.id}-earliset_dryoff_date`"
                      :disabled="isReadOnly">
          </date-input>

          <date-input label="Latest dry-off date"
                      :field-name="`farm_${farm.id}-latest_dryoff_date`"
                      @on-change="calculateDays(farm.id)"
                      :disabled="isReadOnly">
          </date-input>

          <date-input label="Earliest calving date (MA cows)"
                      :field-name="`farm_${farm.id}-earliest_calving_date`"
                      @on-change="calculateDays(farm.id)"
                      :disabled="isReadOnly">
          </date-input>

          <number-input label="Min dry-off length (calculated)"
                        :field-name="`farm_${farm.id}-min_dryoff_days_calc`"
                        disabled>
          </number-input>

          <text-input label="Dry off location"
                      :field-name="`farm_${farm.id}-dryoff_location`"
                      :disabled="isReadOnly">
          </text-input>

        </div>
      </div>
    </div>

    <div class="step-section">
      <radio-input label="Is a staff training session for dry cow/teat sealant insertion required?"
                   field-name="staff_drycow_training"
                   :addEmailNotification="true"
                   :choices="[
                              {value: 'Yes', display: 'Yes'},
                              {value: 'No', display: 'No'},
                              {value: 'Maybe', display: 'Maybe'},
                              ]"
                   :disabled="isReadOnly">
      </radio-input>
      <date-input label="If YES, what date:"
                  field-name="staff_drycow_training_date"
                  :disabled="isReadOnly">
      </date-input>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'ThisSeasonDryOff',
  mixins: [ baseComponent ],
  methods: {
    calculateDays: function(farmId) {
      var latestDryoffDate =  this.getFieldValue(`farm_${farmId}-latest_dryoff_date`)
      var earliestCalvingDate = this.getFieldValue(`farm_${farmId}-earliest_calving_date`)

      if (earliestCalvingDate && latestDryoffDate) {
        let z = new Date(
          latestDryoffDate.split('-')[1] + '/' +
          latestDryoffDate.split('-')[2] + '/' +
          latestDryoffDate.split('-')[0]
        )

        let y = new Date(
          earliestCalvingDate.split('-')[1] + '/' +
          earliestCalvingDate.split('-')[2] + '/' +
          earliestCalvingDate.split('-')[0]
        )

        let diffTime = Math.abs(z - y);
        let days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        this.setFieldValue({
          fieldName:`farm_${farmId}-min_dryoff_days_calc`,
          value: days
        })
      }
    },
    toggleNotifications: function() {
      this.setEmailNotification({
        slug: 'staff-drycow-training',
        value: ['Yes', 'Maybe'].includes(this.getFieldValue('staff_drycow_training', this.$options.name))
      })
    },
  },
  computed: {
    minDate: function() {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return `${yyyy}-${mm}-${dd}`;
    },
  },
};
</script>
